/**
 * OAuth Provider Registry
 *
 * Single source of truth for OAuth provider configurations.
 * To add a new provider, add an entry here with the appropriate endpoint and credential extraction.
 */

const extractStandardCredentials = accessToken => ({
    loginId: accessToken.login_email,
    refreshToken: accessToken.refresh_token,
});

const googleOAuthConfig = {
    type: 'google',
    authEndpoint: '/adwordsauthorize',
    displayName: 'Google Ads',
    extractCredentials: extractStandardCredentials,
};

export const OAuthProviders = {
    'google-ads-offline-conversions-api-s2s': googleOAuthConfig,
    'google-ads-enhanced-conversions-api-s2s': googleOAuthConfig,
    'google-ads-web': googleOAuthConfig,
    'snap-conversions-api-s2s': {
        type: 'snap',
        authEndpoint: '/snapchatauthorize',
        displayName: 'Snapchat',
        extractCredentials: extractStandardCredentials,
    },
    'microsoft-ads-conversions-api-s2s': {
        type: 'microsoft',
        authEndpoint: '/bingauthorize',
        displayName: 'Microsoft Ads',
        extractCredentials: extractStandardCredentials,
    },
};

export const getOAuthProvider = partnerName => OAuthProviders[partnerName] || null;
